/* =========================================================
   Kort-vælgeren som overlay — mtw-kv-loader.js
   Indlæses af layout/theme.liquid, kun når settings.kv_indgange er til og siden ikke er /pages/byg-samling.
   Et klik på en indgang (a[data-mtwkv], snippets/mtw-kv-indgang.liquid og mtw-binders2.js) åbner værktøjet oven på
   siden i stedet for at følge linket. Første gang hentes sections/mtw-samling-app.liquid (?sections=mtw-samling-app),
   stylesheets og scripts (kerne, motor, bro i den rækkefølge); derefter window.MTWC.open(MTWCCore.deeplink(link.search), sted).
   sted er indgangens data-mtwkv (kollektion, kurv, produkt, soegning, menu, samlinger) til målingen; det huskes også i
   sessionStorage (mtwc-kilde), så det gælder, hvis linket følges i stedet (byg-samling-siden læser det).
   Senere klik genbruger værktøjet. Går noget galt, følges linket (/pages/byg-samling?...), så kunden kommer frem alligevel.
   Klik med ctrl/cmd/shift/alt eller midterknap røres ikke ("åbn i ny fane" virker).
   Spec: docs/superpowers/specs/2026-10-13-kort-vaelgeren-indgange-design.md
   ========================================================= */
(function () {
  'use strict';
  if (window.__mtwKvLoader) return;
  window.__mtwKvLoader = true;
  var me = document.currentScript || document.querySelector('script[data-mtwkv-loader]');
  if (!me || !window.fetch || !window.Promise || !document.addEventListener) return; // linkene virker som almindelige links

  var SEKTION = 'mtw-samling-app', VENT_MAX = 12000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var FORSIDE = { mode: 'forside', handle: '', q: '', mangler: false };
  function attr(n) { return me.getAttribute('data-' + n) || ''; }

  var htmlP = null;    // hentningen af sektionen; startes allerede, når fingeren eller musen rammer en indgang
  var klar = null;     // alt indlæst (HTML, stylesheets, scripts). Fejler den, bliver indgangene almindelige links
  var laster = false;  // en åbning venter på indlæsningen: nye klik ignoreres
  var lag = null;      // "Åbner Kort-vælgeren …" over siden, mens der hentes første gang

  function hentHtml() {
    if (!htmlP) {
      htmlP = fetch(ROOT + '?sections=' + SEKTION, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) { var h = d && d[SEKTION]; if (!h || h.indexOf('data-mtwc-root') < 0) throw new Error('tom'); return h; });
      htmlP.then(null, function () { htmlP = null; }); // en fejlet forvarmning hentes igen ved klik
    }
    return htmlP;
  }
  function css(href) {
    return new Promise(function (ok, fejl) {
      if (!href) { fejl(new Error('css')); return; }
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.onload = function () { ok(); };
      l.onerror = function () { fejl(new Error('css')); };
      document.head.appendChild(l);
    });
  }
  // Dynamiske scripts kører ellers i vilkårlig rækkefølge: async = false, og det næste hentes først, når det forrige har kørt.
  function script(src, attrs) {
    return new Promise(function (ok, fejl) {
      if (!src) { fejl(new Error('script')); return; }
      var s = document.createElement('script');
      s.src = src; s.async = false;
      for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) s.setAttribute(k, attrs[k]);
      s.onload = function () { ok(); };
      s.onerror = function () { fejl(new Error('script')); };
      document.body.appendChild(s);
    });
  }
  // HTML'en sættes først ind, når værktøjets stylesheet er hentet, så intet tegnes uden stil. Broen og dens stylesheet er
  // fail-soft: fejler de, åbnes værktøjet uden Mine samlinger. Broen får data-mtwsb og data-logged-in som på byg-samling-siden.
  function indlaes() {
    if (klar) return klar;
    klar = Promise.all([hentHtml(), css(attr('css')), css(attr('bro-css')).then(null, function () {})])
      .then(function (res) {
        var box = document.createElement('div');
        box.innerHTML = res[0];
        while (box.firstChild) document.body.appendChild(box.firstChild);
        return script(attr('core'));
      })
      .then(function () { return script(attr('motor')); })
      .then(function () { return script(attr('bro'), { 'data-mtwsb': '', 'data-logged-in': attr('logged-in') }).then(null, function () {}); })
      .then(function () {
        if (!window.MTWCCore || !window.MTWC || typeof window.MTWC.open !== 'function') throw new Error('motor');
      });
    return klar;
  }

  function visLag() {
    if (lag) return;
    lag = document.createElement('div');
    lag.className = 'mtwkv-vent';
    lag.setAttribute('role', 'status');
    lag.innerHTML = '<span class="mtwkv-vent__boks"><span class="mtwkv-vent__spin" aria-hidden="true"></span>Åbner Kort-vælgeren …</span>';
    document.body.appendChild(lag);
  }
  function skjulLag() { if (lag && lag.parentNode) lag.parentNode.removeChild(lag); lag = null; }

  // search: linkets parametre ("?saet=..."), href: linket at falde tilbage til, link: indgangen (til travl-markering),
  // ctx: en færdig kontekst (genåbning fra historikken) i stedet for search, sted: indgangens navn ('' ved genåbning).
  function aabn(search, href, link, ctx, sted) {
    if (laster) return;
    var opgivet = false, vagt = null;
    function faerdig() {
      clearTimeout(vagt); laster = false; skjulLag();
      if (link) link.removeAttribute('aria-busy');
    }
    function fejl() {
      if (opgivet) return;
      opgivet = true; faerdig();
      if (href) location.href = href;
    }
    function aabnNu() {
      if (opgivet) return;
      faerdig();
      var c = ctx || window.MTWCCore.deeplink(search || '') || FORSIDE;
      // false: intet blev åbnet (fx kurv-kørsel eller luk i gang); linket følges, så et tryk aldrig er dødt.
      try { if (window.MTWC.open(c, sted) === false) fejl(); } catch (e) { fejl(); }
    }
    // Allerede indlæst: åbn straks (også fra et klik, så fokus og rulning huskes fra indgangen).
    if (window.MTWC && typeof window.MTWC.open === 'function' && window.MTWCCore && klar) { aabnNu(); return; }
    laster = true;
    if (link) link.setAttribute('aria-busy', 'true');
    visLag();
    vagt = setTimeout(fejl, VENT_MAX); // hænger hentningen, følges linket
    indlaes().then(aabnNu, fejl);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-mtwkv]') : null;
    if (!a || !a.href || (a.target && a.target !== '_self')) return;
    e.preventDefault();
    var sted = a.getAttribute('data-mtwkv') || '';
    try { if (sted) sessionStorage.setItem('mtwc-kilde', sted); } catch (err) {}
    aabn(a.search, a.href, a, null, sted);
  });
  // Forvarm: hent sektionen, så snart en indgang berøres eller musen går ind over den.
  function varm(e) {
    if (klar || htmlP) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-mtwkv]') : null;
    if (a) hentHtml().then(null, function () {});
  }
  document.addEventListener('mouseover', varm);
  document.addEventListener('touchstart', varm, { passive: true });

  // Tilbage fra kurven (eller genindlæst) til værktøjets trin i historikken: åbn igen med samme indhold, som på byg-samling-siden.
  try {
    var st = history.state;
    if (st && st.mtwcOverlay) aabn('', '', null, st.ctx || FORSIDE, '');
  } catch (e) {}
})();
